import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, map } from 'rxjs';
import { AccessService } from '../services/access.service';
import { DowntimeService } from '../services/downtime.service';
import { UserService } from '../services/user.service';

export const downtimeGuard: CanActivateFn = () => {

  const downtime = inject(DowntimeService);
  const user = inject(UserService);
  const access = inject(AccessService);
  const router = inject(Router);

  return combineLatest([downtime.downtime$, user.permission$]).pipe(
    map(([d]) => {
      if (!access.isAdministrator() && !d.isDown) {
        return router.parseUrl('/');
      }
      return true;
    })
  );
};
